export default __webpack_public_path__ + "static/media/portfolio.de9f19fd.png";